import React from "react";
import Divider from "../../../../../components/shared/Divider/Divider";

export const ReportIndicatorCardGroup = ({ cards, groupName, percentage }) => {
  const pct = Math.max(0, Math.min(100, Number(percentage || 0)));

  return (
    <>
      {/* Divider line */}
      <Divider color="gray200" type="horizontal" />

      <div className="flex justify-between gap-4 py-2.5">
        {/* Group info (title + score) */}
        <div className="flex flex-col gap-1">
          <div className="mb-2.5 text-xs font-bold text-black">{groupName}</div>

          <div>
            <span className="text-xs font-bold text-black">
              {pct.toFixed(0)}
            </span>
            <span className="text-grayTrue500 text-[9px]">/100</span>
          </div>
        </div>

        {/* Cards area */}
        <div className="flex w-full max-w-[75%] flex-wrap justify-end gap-2.5">
          {cards}
        </div>
      </div>
    </>
  );
};
